import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _COVER_INFO_MAP;

import { GeographicAreaType } from '../shared/generated';
import { getLocalTranslation } from '../utils/i18nKit';
/**
 * covers
 */

export var PROFESSIONAL_INDEMNITY = 'professional-indemnity';
export var PROFESSIONAL_INDEMNITY_PER_OCCURRENCE = 'professional-indemnity-per-occurrence';
export var PUBLIC_LIABILITY = 'public-liability';
export var EMPLOYERS_LIABILITY = 'employers-liability';
export var EXCESS_LEVEL = 'excess-level';
export var GOODS_IN_TRANSIT = 'goods-in-transit';
export var CMR_COVER = 'cmr';
export var HIRE_AND_REWARD = 'hire-and-reward';
export var AUTOMOBILE_COVER = 'automobile';
export var CYBER_SECURITY_COVER = 'cyber-security';
export var EXCESS_LIABILITY_COVER = 'excess-liability';
export var COMMERCIAL_BOND_COVER = 'commercial-bond';
export var HIRED_IN_PLANT_COVER = 'hired-in-plant';
export var IR35_INSURANCE_COVER = 'ir35-insurance';
export var OCCUPATIONAL_PERSONAL_ACCIDENT_COVER = 'occupational-personal-accident';
export var PORTABLE_EQUIPMENT_COVER = 'portable-equipment-status';
export var WORKERS_COMPENSATION_COVER = 'workers-compensation';
export var ADDITIONAK_INSURED_COVER = 'additional_insured';
export var WAIVER_OF_SUBROGATIION_COVER = 'waiver_of_subrogation';
export var POLICY_EXTEND_COVER_CLAIMS_USA_CANADA = 'us-claim';
export var FIDELITY_CRIME_SWITCH = 'fidelity-status';
export var FIDELITY_CRIME = 'fidelity';
export var DRIVERS_NEGLIGENCE_SWITCH = 'drivers-neg-status';
export var DRIVERS_NEGLIGENCE = 'drivers-neg';
export var DRIVERS_NEGLIGENCE_DRIVERS_COUNT = 'drivers-neg-count';
export var BUSINESS_INTERUPTION = 'business-interruption-cover-status';
export var DIRECTORS_OFFICERS_COVER = 'directors-officers';
export var CORPORATE_LEGAL_LIABILITY_COVER = 'corporate-legal-liability';
export var EMPLOYMENT_PRACTICES_COVER_SWITCH = 'employment-practices-status';
export var EMPLOYMENT_PRACTICES_COVER = 'employment-practices';
export var EMPLOYMENT_PRACTICES_EXCESS_LEVEL = 'do-excess-level';
export var CYBER_LIABILITY_COVER = 'cyber-liability';
export var CYBER_CRIME_COVER = 'cyber-crime';
export var PROPERTY_COVER = 'property-status';
export var PROPERTY_COVER_TYPE_LIST = 'property';
export var COMPUTER_BREAKDOWN_COVER = 'computer-breakdown';
export var MONEY_ASSAULT_COVER = 'money-assault';
export var PACKAGE_COVER = 'package';
export var PRE_POWER_UNIT_COVER = 'pre-power-unit';
export var DEDUCTIBLE_COVER = 'deductible';
export var RELOADING_COVER = 'reloading';
export var DEBRIS_REMOVAL_COVER = 'debris-removal';
export var EARNED_FREIGHT_COVER = 'earned-freight';
export var FIRE_DEPARTMENT_COVER = 'fire-department';
export var LOSS_DATA_COVER = 'loss-data';
export var REWARD_COVERAGE_COVER = 'reward-coverage';
export var POLLUTANT_CLEAN_UP = 'pollutant-clean-up';
export var REFRIGERATION_BREAKDOWN = 'refrigeration-breakdown';
export var OWNERS_GOODS_EXTENSION = 'owners-goods-extension';
export var NON_OWNED_TRAILER = 'non-owned-trailer';
export var REUSABLE_PACKING_CONTAINERS = 'reusable-packing-containers';
export var TARPS_CHAINS = 'tarps-chains';
export var CEAL_PERCENTAGE = 'ceal_percentage';
export var BI_COW_COVER = 'bi-icow'; // BUSINESS_INTERUPTION

export var PORTABLE_EQUIPMENT = 'portable-equipment'; // PORTABLE_EQUIPMENT_COVER

export var PROFESSIONAL_INDEMNITY_CLAIM_COVER = 'professional-indemnity-claim';
export var PI_WAIVER_OF_SUBROGATION_COVER = 'pi-waiver-of-subrogation';
export var PI_CONTINGENT_BODILY_INJURY_COVER = 'pi-contingent-bodily-injury';
export var PUBLIC_LIABILITY_CLAIM_COVER = 'public-liability-claim';
export var PL_TERRORISM_COVER = 'pl-terrorism';
export var PL_PROPERTY_AND_EQUIPMENT_COVER = 'pl-property-and-equipment';
export var PL_HIRED_NON_OWNED_AUTO_COVER = 'pl-hired-non-owned-auto';
export var PL_WAIVER_OF_SUBROGATION_COVER = 'pl-waiver-of-subrogation';
export var PL_PRIMARY_NON_CONTRIBUTORY_COVER = 'pl-primary-non-contributory';
export var BUSINESS_OWNERS_POLICY_COVER = 'business-owners-policy';
export var BUSINESS_OWNERS_POLICY_CLAIM_COVER = 'business-owners-policy-claim';
export var BOP_PROPERTY = 'property';
export var PROPERTY_EXCESS_COVER = 'property-excess';
export var BOP_TERRORISM_COVER = 'bop-terrorism';
export var BOP_HIRED_NON_OWNED_AUTO_COVER = 'bop-hired-non-owned-auto';
export var BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER = 'bop-hired-non-owned-auto-excess';
export var CRIME_COVER = 'crime';
export var CRIME_EXCESS_COVER = 'crime-excess';
export var CL_EXCESS_COVER = 'cl-excess';
export var CL_TERRORISM_COVER = 'cl-terrorism';
export var CL_MEDIA_LIABILITY_COVER = 'cl-media-liability';
export var LEGAL_EXPENSES_COVER = 'legal-expenses';
export var THIRD_PARTY_BODILY_INJURY = 'third_party_bodily_injury';
export var PROPERTY_DAMAGE = 'property_damage';
export var BUSINESS_HR_COVER = 'business-hr-cover'; // Text

export var NOT_NEED_COVER_TEXT = "I don't need this cover";
export var PROFESSIONAL_INDEMNITY_TEXT = function PROFESSIONAL_INDEMNITY_TEXT() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t; // return $t('kit:professional_indemnity');


  return 'Professional Indemnity';
};
export var PUBLIC_LIABILITY_TEXT = function PUBLIC_LIABILITY_TEXT() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t; // return $t('kit:public_liability');


  return 'Public Liability';
};
export var EMPLOYERS_LIABILITY_TEXT = function EMPLOYERS_LIABILITY_TEXT() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t; // return $t('kit:employers_liability');


  return 'Employers Liability';
};
export var EXCESS_LEVEL_TEXT = function EXCESS_LEVEL_TEXT() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t; // return $t('kit:excess_level');


  return 'Excess Level';
};
export var GOODS_IN_TRANSIT_TEXT = function GOODS_IN_TRANSIT_TEXT() {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t; // return $t('kit:goods_in_transit');


  return 'Goods in transit';
};
export var CMR_COVER_TEXT = function CMR_COVER_TEXT() {
  var _getLocalTranslation6 = getLocalTranslation(),
      $t = _getLocalTranslation6.$t; // return $t('kit:cmr_cover');


  return 'CMR Cover';
};
export var HIRE_AND_REWARD_TEXT = 'Hire and reward';
export var AUTOMOBILE_COVER_TEXT = 'Automobile';
export var CYBER_SECURITY_COVER_COVER_TEXT = 'Cyber Security';
export var EXCESS_LIABILITY_COVER_TEXT = 'Excess (Umbrella) Liability';
export var COMMERCIAL_BOND_COVER_TEXT = 'Fidelity/Crime, Commercial Bond';
export var HIRED_IN_PLANT_COVER_TEXT = 'Hired In Plant';
export var IR35_INSURANCE_COVER_TEXT = 'IR35 insurance';
export var OCCUPATIONAL_PERSONAL_ACCIDENT_COVER_TEXT = 'Occupational Personal Accident';
export var PORTABLE_EQUIPMENT_COVER_TEXT = 'Portable equipment';
export var WORKERS_COMPENSATION_COVER_TEXT = 'Workers’ Compensation';
export var ADDITIONAK_INSURED_COVER_TEXT = 'Additional Insured';
export var WAIVER_OF_SUBROGATIION_COVER_TEXT = 'Waiver Of Subrogation';
export var COVER_INFO_MAP = (_COVER_INFO_MAP = {}, _defineProperty(_COVER_INFO_MAP, PROFESSIONAL_INDEMNITY, {
  value: PROFESSIONAL_INDEMNITY,
  label: PROFESSIONAL_INDEMNITY_TEXT(),
  desc: 'This coverage protects your company against financial loss from people acting on advice you gave or using software you provided.',
  order: 1
}), _defineProperty(_COVER_INFO_MAP, PUBLIC_LIABILITY, {
  value: PUBLIC_LIABILITY,
  label: PUBLIC_LIABILITY_TEXT(),
  desc: 'Protect your company from financial loss arising from property damage or injuries caused by you or your employees.',
  order: 2
}), _defineProperty(_COVER_INFO_MAP, EMPLOYERS_LIABILITY, {
  value: EMPLOYERS_LIABILITY,
  label: EMPLOYERS_LIABILITY_TEXT(),
  desc: 'This covers negligence lawsuits over work-related injuries and occupational diseases.',
  order: 3
}), _defineProperty(_COVER_INFO_MAP, EXCESS_LEVEL, {
  value: EXCESS_LEVEL,
  label: EXCESS_LEVEL_TEXT(),
  desc: 'This is the excess payment deductable if you make a claim on professional indemnity cover.',
  order: 4
}), _defineProperty(_COVER_INFO_MAP, GOODS_IN_TRANSIT, {
  value: GOODS_IN_TRANSIT,
  label: GOODS_IN_TRANSIT_TEXT(),
  desc: 'Covers items from theft, loss or damage while they are being transported by vehicle from one place to another.',
  order: 5
}), _defineProperty(_COVER_INFO_MAP, CMR_COVER, {
  value: CMR_COVER,
  label: CMR_COVER_TEXT(),
  desc: 'Protects your company from financial losses if the goods transported are damaged, lost or stolen during their international road journey.',
  order: 6
}), _defineProperty(_COVER_INFO_MAP, HIRE_AND_REWARD, {
  value: HIRE_AND_REWARD,
  label: HIRE_AND_REWARD_TEXT,
  desc: '',
  order: 7
}), _defineProperty(_COVER_INFO_MAP, DIRECTORS_OFFICERS_COVER, {
  value: DIRECTORS_OFFICERS_COVER,
  label: 'Directors & officers'
}), _defineProperty(_COVER_INFO_MAP, CORPORATE_LEGAL_LIABILITY_COVER, {
  value: CORPORATE_LEGAL_LIABILITY_COVER,
  label: 'Corporate legal liability'
}), _defineProperty(_COVER_INFO_MAP, EMPLOYMENT_PRACTICES_COVER, {
  value: EMPLOYMENT_PRACTICES_COVER,
  label: 'Employment practices'
}), _defineProperty(_COVER_INFO_MAP, CYBER_LIABILITY_COVER, {
  value: CYBER_LIABILITY_COVER,
  label: 'Cyber'
}), _defineProperty(_COVER_INFO_MAP, CYBER_CRIME_COVER, {
  value: CYBER_CRIME_COVER,
  label: 'Cyber crime cover'
}), _defineProperty(_COVER_INFO_MAP, PROPERTY_COVER, {
  value: PROPERTY_COVER,
  label: 'Do you require property cover?'
}), _defineProperty(_COVER_INFO_MAP, BUSINESS_HR_COVER, {
  value: BUSINESS_HR_COVER,
  label: 'Do you require business HR cover?'
}), _defineProperty(_COVER_INFO_MAP, AUTOMOBILE_COVER, {
  value: AUTOMOBILE_COVER,
  label: AUTOMOBILE_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, CYBER_SECURITY_COVER, {
  value: CYBER_SECURITY_COVER,
  label: CYBER_SECURITY_COVER_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, EXCESS_LIABILITY_COVER, {
  value: EXCESS_LIABILITY_COVER,
  label: EXCESS_LIABILITY_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, COMMERCIAL_BOND_COVER, {
  value: COMMERCIAL_BOND_COVER,
  label: COMMERCIAL_BOND_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, HIRED_IN_PLANT_COVER, {
  value: HIRED_IN_PLANT_COVER,
  label: HIRED_IN_PLANT_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, IR35_INSURANCE_COVER, {
  value: IR35_INSURANCE_COVER,
  label: IR35_INSURANCE_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, OCCUPATIONAL_PERSONAL_ACCIDENT_COVER, {
  value: OCCUPATIONAL_PERSONAL_ACCIDENT_COVER,
  label: OCCUPATIONAL_PERSONAL_ACCIDENT_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, PORTABLE_EQUIPMENT_COVER, {
  value: PORTABLE_EQUIPMENT_COVER,
  label: PORTABLE_EQUIPMENT_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, WORKERS_COMPENSATION_COVER, {
  value: WORKERS_COMPENSATION_COVER,
  label: WORKERS_COMPENSATION_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, ADDITIONAK_INSURED_COVER, {
  value: ADDITIONAK_INSURED_COVER,
  label: ADDITIONAK_INSURED_COVER_TEXT
}), _defineProperty(_COVER_INFO_MAP, WAIVER_OF_SUBROGATIION_COVER, {
  value: WAIVER_OF_SUBROGATIION_COVER,
  label: WAIVER_OF_SUBROGATIION_COVER_TEXT
}), _COVER_INFO_MAP);
export var TEMPORARY_CMS_COVER_INFO_LIST = Object.values(COVER_INFO_MAP).filter(function (item) {
  return [COVER_INFO_MAP[AUTOMOBILE_COVER].value, COVER_INFO_MAP[CYBER_CRIME_COVER].value, COVER_INFO_MAP[DIRECTORS_OFFICERS_COVER].value, COVER_INFO_MAP[EMPLOYERS_LIABILITY].value, COVER_INFO_MAP[EXCESS_LIABILITY_COVER].value, COVER_INFO_MAP[COMMERCIAL_BOND_COVER].value, COVER_INFO_MAP[GOODS_IN_TRANSIT].value, COVER_INFO_MAP[HIRE_AND_REWARD].value, COVER_INFO_MAP[HIRED_IN_PLANT_COVER].value, COVER_INFO_MAP[IR35_INSURANCE_COVER].value, COVER_INFO_MAP[OCCUPATIONAL_PERSONAL_ACCIDENT_COVER].value, COVER_INFO_MAP[PORTABLE_EQUIPMENT_COVER].value, COVER_INFO_MAP[PROFESSIONAL_INDEMNITY].value, COVER_INFO_MAP[PUBLIC_LIABILITY].value, COVER_INFO_MAP[WORKERS_COMPENSATION_COVER].value].includes(item.value);
});
export var coverageGeographicAreasMap = {
  UKOnly: {
    value: GeographicAreaType.UK_ONLY,
    label: 'UK only'
  },
  USOnly: {
    value: GeographicAreaType.US_ONLY,
    label: 'US only'
  },
  certainCountries: {
    value: GeographicAreaType.CERTAIN_COUNTRIES,
    label: 'Certain countries'
  },
  EuropeanUnion: {
    value: GeographicAreaType.EUROPEAN_UNION,
    label: 'European Union'
  },
  EUExceptCertainCountries: {
    value: GeographicAreaType.EU_EXCEPT_CERTAIN_COUNTRIES,
    label: 'EU except certain countries'
  },
  worldwideExceptCertainCountries: {
    value: GeographicAreaType.WORLDWIDE_EXCEPT_CERTAIN_COUNTRIES,
    label: 'Worldwide except certain countries'
  },
  worldwide: {
    value: GeographicAreaType.WORLDWIDE,
    label: 'Worldwide'
  }
};
export var coverageGeographicAreasList = Object.values(coverageGeographicAreasMap);